<template>
	<div>
		
		<vs-table stripe noDataText="فاکتوری موجود نیست." class="mt-4" :data="factorsList" >

			<template slot="header">
				<vs-row class="px-5 my-4">
					<vs-col vs-w="3">
						<div @keydown.enter="search()">
							<vs-input class="w-full searchInput" v-model="title" placeholder="جستجو..." />
						</div>
					</vs-col>
					<vs-col vs-w="6">
					</vs-col>
					<vs-col vs-w="3" class="px-2">
						<v-select :options="statusList" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="searchInput" v-model="status" />
					</vs-col>
				</vs-row>
			</template>

			<template slot="thead">
				<vs-th>	شماره فاکتور </vs-th>
				<vs-th>	نام و نام خانوادگی - موبایل </vs-th>
				<vs-th>	عنوان </vs-th>
				<vs-th>	وضعیت </vs-th>
				<vs-th> نوع پرداخت </vs-th>
				<vs-th> شماره سفارش </vs-th>
				<vs-th> </vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td>
						{{data[indextr].factor_number}}
					</vs-td>

					<vs-td>
						{{data[indextr].order.user.name}} {{data[indextr].order.user.last_name}} - {{data[indextr].order.user.phone_number}}
					</vs-td>

					<vs-td>
						{{data[indextr].title}}
					</vs-td>
					<vs-td>
						<span :class="itemRowBackground(data[indextr].status)" class="statusStyle darken-1">
							{{setStatus(data[indextr].status)}}
						</span>
					</vs-td>
					<vs-td>
						{{setType(data[indextr].type)}}
					</vs-td>
					<vs-td>
						{{data[indextr].order_number}}
					</vs-td>
					<vs-td>
						<!-- <vs-button class="mb-2" size="small">پرداخت</vs-button> -->
						<feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="mr-4 button-link" @click="editFactor(data[indextr].id)"/>
						<feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="button-link" @click="deleteFactor(data[indextr].id)"/>
            		</vs-td>
				</vs-tr>
				<!-- <div class="float-left">
					<vs-pagination class="mt-4" :total="last_page" v-model="table_options.current_page"></vs-pagination>
				</div> -->
			</template>
		</vs-table>

		<EditFactor :popupEditFactor='popupEditFactor' :factorId='editFactorId' @updatePopupEditFactor='updatePopupEditFactor'/>

		<DeleteFactor :popupDeleteFactor='popupDeleteFactor' :factorId='deleteFactorId' @updatePopupDeleteFactor='updatePopupDeleteFactor'/>

	</div>
</template>

<script>
import EditFactor from './Edit'
import DeleteFactor from './Delete'
import vSelect from 'vue-select'

export default {
	components: {
		EditFactor,
		DeleteFactor,
		vSelect,
	},

	data() {
		return{
			popupEditFactor: false,
			popupDeleteFactor: false,

			editFactorId: 0,
			deleteFactorId: 0,

            last_page: 0,
			table_options: {
				current_page: 1,
			},

			title: '',

			status: {
				label: 'همه',
				value: 'all'
			},

			statusList: [
				{
                    label: 'همه',
                    value: 'all'
                },
                {
                    label: 'پرداخت نشده',
                    value: 'unpaid'
                },
                {
                    label: 'پرداخت شده',
                    value: 'paid'
                },
                {
                    label: 'کنسل شده',
                    value: 'canceled'
                },
            ],
		}
	},

	computed: {
		factorsList() {
      		return this.$store.state.factors.factors
    	}
	},

	watch: {
		"table_options.current_page": function () {
			this.getFactors();
		},

		status(){
			this.table_options.current_page = 1
			this.getFactors();
		}
	},

	created(){
		this.getFactors();
	},

	methods: {
        formatPrice(value) {
            let val = (value / 1).toFixed(0).replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},

		itemRowBackground(status) {
			if (status === "unpaid") return "bg-danger";
			else if (status === "paid") return "bg-success";
			else if (status === "canceled") return "bg-secondary";
		},

		
		getFactors() {
			this.$vs.loading()
			let data = {
				type: 'product',
				title: this.title,
				status: this.status.value,
				page: this.table_options.current_page
			}
			this.$store.dispatch('getFactors', data )
			.then((res) => {
				this.last_page = res.data.data.last_page;
				this.$vs.loading.close()
			})
			.catch(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'خطا در اتصال به اینترنت',
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'warning'
				})
			})
		},

		search(){
			this.table_options.current_page = 1
			this.getFactors()
		},

		setStatus(status) {
			if(status == 'canceled') {
				return 'کنسل شده'
			}
			else if(status == 'paid') {
				return 'پرداخت شده'
			}
			else {
				return 'پرداخت نشده'
			}
		},

		setType(type) {
			if(type == 1) {
				return '70% پیش پرداخت و 30 % هنگام تحویل محصول'
			}
			else if(type == 2) {
				return '50% پیش پرداخت و 50% هنگام تحویل محصول'
			}
			else if(type == 3) {
				return '50% پیش پرداخت و 50% پس از نصب محصول'
			}
			else if(type == 4) {
				return '100% پس از نصب محصول'
			}
		},

		setTime(date) {
			if(date != null) {
				const date_time = date.split(" ");
				return date_time[0]
			}
			else {
				return 'پرداخت نشده'
			}
			
		},

		editFactor(id){
			this.popupEditFactor = true
			this.editFactorId = id
		},
		
		deleteFactor(id){
			this.popupDeleteFactor = true
			this.deleteFactorId = id
		},

		updatePopupEditFactor(value){
            this.popupEditFactor = value
		},
		
		updatePopupDeleteFactor(value){
            this.popupDeleteFactor = value
        },
  	}
}
</script>

<style>
.center {
    padding: 2.2rem !important;
}
.button-link {
	cursor: pointer;
}
.vs-con-table .vs-con-tbody {
    border: unset !important;
}
</style>